import { ApiService } from '@b2b/common/services/api/types';
import { GridStateFactory } from '@b2b/common/factories/gridState/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { TODO } from '@b2b/types/core';
import angular, { IScope, ITimeoutService } from 'angular';
import { getComboStatus } from '../../../../../../programs/combos/utils/combo-status';

const POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS = {
  LOCALE: {
    E_DATE_UNAVAILABLE: 'The selected combo event is not available on this date. Please choose a different date.',
    ADVANCE_PUR_DATE: 'Advance purchase date',
    CURRENT_DATE: 'Current Date',
    TILE_COLOR: 'Tile color',
    TICKET: 'Ticket',
    CALENDAR: 'Calendar',
    CLOCK: 'Clock',
  },
  ENUM: {
    ROLLUP: 'rollup',
    PRESELL: 'presell',
    CURRENT: 'current',
    TICKET: 'ticket',
    CALENDAR: 'calendar',
    CLOCK: 'clock',
    OBJECT: 'object',
  },
};

PosCreatePagesFormsComboEventController.$inject = [
  '$scope',
  '$timeout',
  'ApiService',
  'PosConfigService',
  'TemplatesHelpersService',
  'GridStateFactory',
  'CalendarService',
];

function PosCreatePagesFormsComboEventController(
  $scope: IScope & { posCreatePagesFormsComboEvent: TODO },
  $timeout: ITimeoutService,
  ApiService: ApiService,
  PosConfigService: TODO,
  TemplatesHelpersService: TODO,
  GridStateFactory: GridStateFactory,
  CalendarService: CalendarService,
) {
  const ctrl = {
    queryTimer: false as TODO,

    model: {} as TODO,
    list: [] as TODO[],

    title: '',
    subTitle: '',
    color: '',
    selected: '' as TODO,
    presellDate: new Date(),
    eventDateType: {} as TODO,
    eventDateTypes: [
      {
        type: POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.ENUM.CURRENT,
        label: POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.LOCALE.CURRENT_DATE,
      },
      {
        type: POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.ENUM.PRESELL,
        label: POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.LOCALE.ADVANCE_PUR_DATE,
      },
    ],

    selectedIcon: {} as TODO,
    iconTypes: [
      {
        type: POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.ENUM.TICKET,
        label: POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.LOCALE.TICKET,
      },
      {
        type: POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.ENUM.CALENDAR,
        label: POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.LOCALE.CALENDAR,
      },
      {
        type: POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.ENUM.CLOCK,
        label: POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.LOCALE.CLOCK,
      },
    ],

    colorCodes: {
      textColor: '',
      backgroundColor: '',
    },

    spectrumConfig: {
      titleText: POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.LOCALE.TILE_COLOR,
      color: '' as TODO,
    },
    gridState: new GridStateFactory(),

    pageSize: 200,

    formError: '',
    reduceList: false,
    isLoaded: false,
    searching: false,
    lastSearchQuery: '',
    totalServerItems: 1,
    currentCombo: false as TODO,
    loadTimeout: false as TODO,

    presellDateWatcher: null as TODO,
    eventDateWatcher: null as TODO,
    showMore: { showMoreLabel: '', hasMore: false } as { showMoreLabel: string; hasMore: boolean },

    init() {
      $scope.$on('PosCreatePagesFormsController::Update', ctrl.onPosCreatePagesFormsControllerUpdate);

      $scope.$watch('posCreatePagesFormsComboEvent.selected', ctrl.onSelected);

      $scope.$watchCollection('posCreatePagesFormsComboEvent.colorCodes', ctrl.onColorCodesUpdate);

      $scope.$on('destroy', function () {
        $timeout.cancel(ctrl.queryTimer);
        $timeout.cancel(ctrl.loadTimeout);
      });
    },

    initDateWatchers() {
      if (ctrl.presellDateWatcher) {
        ctrl.presellDateWatcher();
      }

      if (ctrl.eventDateWatcher) {
        ctrl.eventDateWatcher();
      }

      ctrl.eventDateWatcher = $scope.$watch('posCreatePagesFormsComboEvent.eventDateType', ctrl.onEventDateTypeUpdate);
      ctrl.presellDateWatcher = $scope.$watch('posCreatePagesFormsComboEvent.presellDate', ctrl.onPresellDateUpdate);
    },

    getCombos(searchQuery?: string) {
      ctrl.gridState.updateGridState(null, ctrl.pageSize, 'name', 'asc', '');
      ctrl.gridState.gridState.search = searchQuery || '';

      const props = Object.assign({}, ctrl.gridState.getGridState(), { summary: true });

      ApiService.combo.templates
        .list(props)
        .then((response) => {
          ctrl.totalServerItems = response.data.payload.pagination.count;
          ctrl.list = ctrl.process(response.data.payload.list, ctrl.totalServerItems);
          ctrl.isLoaded = true;
        })
        .catch(() => {
          ctrl.totalServerItems = 0;
          ctrl.list = [];
          ctrl.setCombo();
          ctrl.isLoaded = true;
        });
    },

    getCombo(id: TODO) {
      ApiService.combo.templates
        .get(id)
        .then((response) => {
          ctrl.currentCombo = response.data.payload;
          ctrl.setCombo();
          ctrl.getCombos();
        })
        .catch(() => {
          ctrl.currentCombo = false;
        });
    },

    findIcon(type: string) {
      let r = {} as TODO;

      for (let i = 0, ii = ctrl.iconTypes.length; i < ii; i++) {
        if (ctrl.iconTypes[i].type === type) {
          r = ctrl.iconTypes[i];
          break;
        }
      }

      return r;
    },

    showAutoComplete(field: string) {
      const input = $('#' + field);

      ctrl.reduceList = false;

      $timeout(() => {
        input.trigger('focus');
      }, 0);
    },

    hasSelected() {
      return ctrl.selected && typeof ctrl.selected === POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.ENUM.OBJECT;
    },

    isEventDateType(type: string) {
      return ctrl.eventDateType.type === type;
    },

    getTitle() {
      let r = 'Enter a title';
      if (ctrl.selected && ctrl.selected.name) {
        r = ctrl.selected.name;
      }
      return r;
    },

    process(combos: TODO, count: TODO) {
      const result = combos.filter((combo: TODO) => {
        const status = getComboStatus({
          startTime: CalendarService.parseDate(combo.startTime),
          endTime: CalendarService.parseDate(combo.endTime),
          priceList: combo.priceList,
          discountId: combo.discountId,
        });

        return status !== 'Incomplete';
      });
      const currentCount = (ctrl.gridState.gridState.page || 1) * ctrl.gridState.gridState.pageSize;

      if (count && count > currentCount) {
        ctrl.showMore = {
          showMoreLabel: `Show ${ctrl.pageSize} more of ${count}`,
          hasMore: true,
        };
      } else {
        ctrl.showMore = {
          showMoreLabel: '',
          hasMore: false,
        };
      }

      return result;
    },

    remove() {
      $scope.$emit('PosCreatePagesFormsController::RemoveTile', ctrl.model);
    },

    cancel() {
      $scope.$emit('PosCreatePagesFormsController::Cancel', ctrl.model);
    },

    setCombo() {
      const foundCombo = TemplatesHelpersService.findTemplate(ctrl.list, ctrl.model.id);

      if (foundCombo || ctrl.currentCombo) {
        ctrl.selected = !foundCombo ? ctrl.currentCombo : ctrl.list[foundCombo.index];

        $timeout(() => {
          if (ctrl.model.icon) {
            ctrl.selectedIcon = ctrl.findIcon(ctrl.model.icon);
          }

          if (ctrl.model.name && ctrl.model.name.length) {
            ctrl.title = ctrl.model.name !== ctrl.selected.name ? ctrl.model.name : '';
          }

          ctrl.subTitle = ctrl.model.subTitle || '';

          if (ctrl.model.type === POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.ENUM.PRESELL) {
            ctrl.presellDate =
              ctrl.model.presell && ctrl.model.presell.date
                ? PosConfigService.parsePresellDate(ctrl.model.presell.date)
                : new Date();
            ctrl.eventDateType = ctrl.eventDateTypes[1];
          } else {
            ctrl.presellDate = new Date();
            ctrl.eventDateType = ctrl.eventDateTypes[0];
          }
        }, 0);
      }
    },

    resetSelected() {
      let foundCombo: TODO;
      $timeout(() => {
        if (!ctrl.hasSelected()) {
          foundCombo = TemplatesHelpersService.findTemplate(ctrl.list, ctrl.model.id);

          if (foundCombo || ctrl.currentCombo) {
            ctrl.selected = !foundCombo ? ctrl.currentCombo : ctrl.list[foundCombo.index];
          }
        }
        ctrl.reduceList = false;
      }, 0);
    },

    search(field: string) {
      ctrl.searching = true;

      const props = Object.assign({}, ctrl.gridState.getGridState(), { summary: true });

      ApiService.combo.templates
        .list(props)
        .then((response: TODO) => {
          ctrl.list = ctrl.process(response.data.payload.list, response.data.payload.pagination.count);

          ctrl.searching = false;

          if (field) {
            $scope.$broadcast('CustomTypeahead::FilterResults', { field: field });
          }
        })
        .catch(() => {
          ctrl.list = [];
          ctrl.searching = false;
        });
    },

    filterList(force: boolean, field: string) {
      const timeoutMS = force ? 0 : 500;

      if (ctrl.queryTimer) {
        $timeout.cancel(ctrl.queryTimer);
      }

      ctrl.queryTimer = $timeout(() => {
        if (force || (typeof ctrl.selected === 'string' && ctrl.lastSearchQuery !== ctrl.selected)) {
          if (!force) {
            ctrl.gridState.setPropertyValue('pageSize', ctrl.pageSize);
          } else {
            ctrl.gridState.setPropertyValue('pageSize', ctrl.gridState.gridState.pageSize + ctrl.pageSize);
          }
          ctrl.gridState.gridState.search = ctrl.hasSelected() ? '' : ctrl.selected;
          ctrl.lastSearchQuery = ctrl.gridState.gridState.search;
          ctrl.search(field);
        }
      }, timeoutMS);
    },

    showMoreResults(item: TODO) {
      switch (item.field) {
        case 'pos-create-pages-forms-comboEvent-list':
          ctrl.filterList(true, item.field);
          break;
      }
    },

    done() {
      ctrl.model.name = '';
      if (ctrl.title) {
        ctrl.model.name = ctrl.title;
      } else if (ctrl.selected && ctrl.selected.name) {
        ctrl.model.name = ctrl.selected.name;
      }

      if (ctrl.hasSelected()) {
        ctrl.model.id = ctrl.selected.id;
      }

      ctrl.model.subTitle = ctrl.subTitle || '';

      if (ctrl.selectedIcon && ctrl.selectedIcon.hasOwnProperty('type')) {
        ctrl.model.icon = ctrl.selectedIcon.type;
      } else {
        ctrl.model.icon = 'none';
      }

      ctrl.model.color = PosConfigService.tiles.toColor(ctrl.color);
      if (!ctrl.model.color.a) {
        ctrl.model.color.a = 1;
      }

      if (ctrl.model.config.pageId) {
        ctrl.model.config.pageId = null;
        delete ctrl.model.config.pageId;
      }

      if (ctrl.eventDateType.type === POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.ENUM.PRESELL) {
        ctrl.model.presell = {
          date: PosConfigService.dateToPresellDate(ctrl.presellDate),
        };
      } else {
        ctrl.model.presell = null;
        delete ctrl.model.presell;
      }

      ctrl.model.type = POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.ENUM.ROLLUP;

      PosConfigService.updateTile(PosConfigService.pages.getSelectedPageId(), ctrl.model);
      $scope.$emit('PosCreatePagesFormsController::UpdateTile');
    },

    isLoading() {
      return ctrl.searching;
    },

    onSelected(_n: TODO, _o: TODO) {
      ctrl.model.hasError = false;

      if (ctrl.hasSelected() && ctrl.model.id === ctrl.selected.id) {
        if (ctrl.model.name && ctrl.model.name.length) {
          ctrl.title = ctrl.model.name !== ctrl.selected.name ? ctrl.model.name : '';
        } else {
          ctrl.title = '';
        }
      } else {
        ctrl.title = '';
        ctrl.subTitle = '';
      }

      if (ctrl.loadTimeout) {
        $timeout.cancel(ctrl.loadTimeout);
      }
      ctrl.loadTimeout = $timeout(() => {
        if (ctrl.model.hasOwnProperty(POS_CREATE_PAGES_FORMS_COMBO_EVENT_STRINGS.ENUM.PRESELL)) {
          ctrl.eventDateType = ctrl.eventDateTypes[1];
          ctrl.presellDate = PosConfigService.parsePresellDate(ctrl.model.presell.date);
        } else {
          ctrl.eventDateType = ctrl.eventDateTypes[0];
        }
      }, 200);
    },

    onEventDateTypeUpdate(_n: TODO, _o: TODO) {
      ctrl.formError = '';
    },

    onPresellDateUpdate(_n: TODO, _o: TODO) {
      ctrl.formError = '';
    },

    onPosCreatePagesFormsControllerUpdate(_e: TODO, data: TODO) {
      if (data.config.type === 'comboEvent') {
        ctrl.selected = '';
        ctrl.formError = '';

        ctrl.model = data;
        ctrl.spectrumConfig.color = '#000000';
        ctrl.color = PosConfigService.tiles.toHex(PosConfigService.tiles.colorToRgb(ctrl.model));
        $timeout(() => {
          ctrl.spectrumConfig.color = ctrl.color;
        }, 0);

        if (ctrl.model.id) {
          if (ctrl.currentCombo.id !== ctrl.model.id) {
            ctrl.getCombo(ctrl.model.id);
          } else {
            ctrl.setCombo();
          }
        } else {
          ctrl.currentCombo = false;
          ctrl.getCombos();
        }

        ctrl.initDateWatchers();
      }
    },

    onColorCodesUpdate(n: TODO, o: TODO) {
      if (n && n !== o) {
        ctrl.color = n.backgroundColor;
      }
    },
  };

  $scope.posCreatePagesFormsComboEvent = ctrl;
  ctrl.init();
}

export const PosCreatePagesFormsComboEventControllerModule = angular
  .module('acme.view.application.pos.create.pages.forms.comboEvent.controllers', [
    'acme.common.service.api',
    'acme.common.service.posConfig',
    'acme.common.service.templates.helpers',
    'acme.common.service.helpers',
    'acme.common.factory.gridState',
    'acme.common.service.calendar',
  ])
  .controller('PosCreatePagesFormsComboEventController', PosCreatePagesFormsComboEventController).name;
